import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTicketAlt, FaUser, FaClock, FaCommentDots, FaUserTag } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getTecnicomto, newRegistromto } from '../../../redux/actions';
import { useNavigate } from 'react-router-dom';
import PacmanLoader from 'react-spinners/PacmanLoader';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import styles from "./Card.module.css";

const MySwal = withReactContent(Swal);

const Card = ({ ticketData, equipoCod, email }) => {
    const dispatch = useDispatch();
    const tecnicomto = useSelector((state) => state.tecnicomto);
    const navigate = useNavigate();
    const [selectedTechnician, setSelectedTechnician] = useState('');
    const [observation, setObservation] = useState('');
    const [showAssign, setShowAssign] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    useEffect(() => {
        dispatch(getTecnicomto());
    }, [dispatch]);

    const handleTechnicianChange = (e) => {
        const value = e.target.value;
        setSelectedTechnician(value);
        setShowAssign(value !== '');
    };

    const handleAssign = async () => {
        setLoading(true);

        if (selectedTechnician === '-1') {
            const data = {
                fecha: new Date().toISOString(),
                Observacion: observation,
                TicketId: ticketData.TicketId,
                nombreUsuario: 'Pendiente',
                EstadoId: 3,
                correoUsuario: '',
                UsuarioId: null,
                flag: 2
            };

            try {
                await dispatch(newRegistromto(data));
                setAlertMessage('El ticket queda en estado pendiente.');
                setSelectedTechnician('');
                setObservation('');
                setShowAssign(false);
            } catch (error) {
                MySwal.fire({
                    title: 'Error',
                    text: 'Hubo un error al asignar el ticket.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        } else {
            const selectedTecnico = tecnicomto.find(tecnico => tecnico.id === parseInt(selectedTechnician));

            const data = {
                fecha: new Date().toISOString(),
                Observacion: observation,
                TicketId: ticketData.TicketId,
                nombreUsuario: selectedTecnico.nombre,
                EstadoId: 2,
                correoUsuario: selectedTecnico.email,
                UsuarioId: selectedTecnico.id,
                flag: 2
            };

            try {
                await dispatch(newRegistromto(data));
                setAlertMessage('Se ha asignado o actualizado el técnico.');
                setSelectedTechnician('');
                setObservation('');
                setShowAssign(false);
            } catch (error) {
                MySwal.fire({
                    title: 'Error',
                    text: 'Hubo un error al asignar el ticket.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        if (alertMessage) {
            MySwal.fire({
                title: 'Éxito',
                text: alertMessage,
                icon: 'success',
                confirmButtonText: 'Aceptar'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/asigtecmto');
                    window.location.reload();
                }
            });

            const timeout = setTimeout(() => {
                setAlertMessage('');
            }, 3000);

            return () => clearTimeout(timeout);
        }
    }, [alertMessage, navigate]);

    const handleResolution = () => {
        navigate(`/resoltickmto/${ticketData.TicketId}`, {
            state: {
                nombre: ticketData.nombre,
                fecha: ticketData.fecha,
                tecnico: equipoCod,
                UsuarioId: ticketData.UsuarioId,
                email: email,
                observacion1: ticketData.observacionesEstado1
            }
        });
    };

    const getStatusStyle = () => {
        switch (ticketData.EstadoId) {
            case 1: return styles.created;
            case 2: return styles.assigned;
            case 3: return styles.pending;
            default: return "";
        }
    };

    const formatDate = (dateString) => {
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        try {
            return new Date(dateString).toLocaleString('es-ES', options);
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <div className={styles.ticketId}>
                    <FaTicketAlt color="#8b5cf6" />
                    <span>#{ticketData.TicketId}</span>
                </div>
                <div className={`${styles.statusBadge} ${getStatusStyle()}`}>
                    {ticketData.Estado}
                </div>
            </div>

            <div className={styles.cardBody}>
                <div className={styles.infoRow}>
                    <FaUser className={styles.labelIcon} color="#94a3b8" />
                    <span className={styles.label}>Usuario:</span>
                    <span className={styles.value}>{ticketData.nombre}</span>
                </div>

                <div className={styles.infoRow}>
                    <FaClock className={styles.labelIcon} color="#94a3b8" />
                    <span className={styles.label}>Fecha:</span>
                    <span className={styles.value}>{formatDate(ticketData.fecha)}</span>
                </div>

                {equipoCod && (
                    <div className={styles.infoRow}>
                        <FaUserTag className={styles.labelIcon} color="#8b5cf6" />
                        <span className={styles.label}>Técnico:</span>
                        <span className={styles.value}>{equipoCod}</span>
                    </div>
                )}

                <div className={styles.observationBlock}>
                    <div className={styles.obsLabel}>
                        <FaCommentDots />
                        <span>SOLICITUD INICIAL:</span>
                    </div>
                    <p className={styles.obsContent}>{ticketData.observacion}</p>
                </div>

                {ticketData.EstadoId === 2 && (
                    <FaCheckCircle
                        onClick={handleResolution}
                        className={styles.resolutionIcon}
                        title="Resolver Ticket"
                    />
                )}

                <div className={styles.actionArea}>
                    <div className={styles.selectGroup}>
                        <select value={selectedTechnician} onChange={handleTechnicianChange} className={styles.select}>
                            <option value="">Selecciona un técnico para asignar</option>
                            <option value="-1">Marcar como Pendiente</option>
                            {tecnicomto.map((tecnico) => (
                                <option key={tecnico.id} value={tecnico.id}>{tecnico.nombre}</option>
                            ))}
                        </select>
                        <FaUserPlus style={{ position: 'absolute', right: '16px', top: '16px', color: '#94a3b8', pointerEvents: 'none' }} />
                    </div>

                    {showAssign && (
                        <div className={styles.assignForm}>
                            <input
                                type="text"
                                value={observation}
                                onChange={(e) => setObservation(e.target.value)}
                                placeholder="Escribe instrucciones o notas para el técnico..."
                                className={styles.input}
                            />
                            <button onClick={handleAssign} className={styles.button}>
                                Confirmar Asignación
                            </button>
                        </div>
                    )}
                </div>

                {loading && (
                    <div className={styles.spinnerContainer}>
                        <PacmanLoader color="#8b5cf6" loading={loading} size={30} />
                    </div>
                )}
            </div>
        </div>
    );
};

// Internal FaUserPlus for the select icon
const FaUserPlus = ({ style }) => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 640 512" style={style} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
    </svg>
);

export default Card;
